export function canSafelyDivideFlowRates(dividend: number, divisor: number): boolean {
  return Number.isFinite(dividend) && Number.isFinite(divisor) && divisor !== 0;
}

export function calculateSampleRate(receivedFps: number, storedFps: number): number {
  if (storedFps === 0) {
    return 0; // don't divide by zero
  }

  const sampleRate = receivedFps / storedFps;

  if (sampleRate > 1 && sampleRate < 1.1) {
    return 1;
  }

  return Math.round(sampleRate * 10) / 10;
}
